import {decrypt, encrypt} from '@/utils/CryptoJSUtils'
import md5 from 'js-md5'

const keyPrefix = "metabolome_16s_"
// export const saveDataToLocalStorage = (key, value) => {
//   if(!key || !value) {
//     return
//   }
//   var saveValue = encrypt(value)
//   localStorage.setItem(doubleEncode(key), saveValue)
// }
//
// export const getDataInLocalStorage = (key) => {
//   if(!key) {
//     return ''
//   }
//   var value = localStorage.getItem(doubleEncode(key))
//   if(!value) {
//     return ''
//   }
//   return decrypt(value)
// }
// export const removeDataInLocalStorage = (key) => {
//   if(!key) {
//     return ''
//   }
//   var value = localStorage.removeItem(doubleEncode(key))
//   if(!value) {
//     return ''
//   }
//   return decrypt(value)
// }
// export const doubleEncode = (value) => {
//   if(!value) return ''
//   value = keyPrefix + value
//   return  encrypt(value) + md5.base64(value)
// }
export const saveDataToLocalStorage = (key, value) => {
  if (!key || !value) {
    return
  }
  localStorage.setItem(AddFix(key), value)
}

export const getDataInLocalStorage = (key) => {
  if (!key) {
    return ''
  }
  var value = localStorage.getItem(AddFix(key))
  if (!value) {
    return ''
  }
  return value
}
export const removeDataInLocalStorage = (key) => {
  if (!key) {
    return ''
  }
  var value = localStorage.removeItem(AddFix(key))
  if (!value) {
    return ''
  }
  return value
}
export const AddFix = (value) => {
  value = keyPrefix + value
  return value

}
